export const formatTanggal = (value) => {
  if (value) {
    var tanggal = value.split("-");
    return tanggal[2] + "/" + tanggal[1] + "/" + tanggal[0];
  } else {
    return "";
  }
};
